export const originalCoordinatesPavilion15 = [
    [22.95395312260777, 40.62921374783707], // Top-left
    [22.954408394695548, 40.6293488858949], // Top-right
    [22.954965599695697, 40.62825756389924], // Bottom-right
    [22.954509224473753, 40.628125621917434], // Bottom-left

];

export const originalCoordinatesPavilion02 = [
    [22.9560390697788, 40.62866422451438], // Point 1
    [22.95628998575404, 40.628835751502265], // Point 2
    [22.957306417837458, 40.627839829748666], // Point 3
    [22.957052460704688, 40.62772210696323], // Point 4
  
];

export const originalCoordinatesOpenAirSpaceB08 = [
    [22.955990118192005, 40.627937516876585], // Point 1
    [22.956046631120472, 40.627951957542024], // Point 2
    [22.956599904209128, 40.62676667532594], // Point 4
    [22.95656955472529, 40.626755555336274], // Point 3

];

export const originalCoordinatesPavilion06 = [
    [22.95561680215500, 40.62553295714068], // Point 1
    [22.95703945410878, 40.62590185894237], // Point 2
    [22.95714326643065, 40.625675800590415], // Point 4
    [22.95570918716365, 40.6253013184359],  // Point 3

];


export const originalCoordinatesPavilion07 = [
    [22.9561248795755, 40.62640947267229], // Point 1
    [22.95659167825687, 40.626532657767314], // Point 2
    [22.95684412228269, 40.62597668496409],  // Point 4
    [22.9563764272433, 40.62585444877817],   // Point 3

];

export const originalCoordinatesPavilion16 = [
    [22.956068720265137, 40.62797367401052], // Point 1
    [22.95651850236507, 40.628091471657825],  // Point 2
    [22.956817592693852, 40.62744904666499],   // Point 4
    [22.956360545586705, 40.62732599664264],   // Point 3
   
];


export const originalCoordinatesPavilion01 = [
    [22.9547495534871, 40.62942552764969], // Point 1
    [22.954879284329195, 40.629570685101896], // Point 2
    [22.955754112821694, 40.62916929156435],  // Point 4
    [22.95558363946563, 40.62899869985233], 
  
];

export const originalCoordinatesPavilion05 = [
    [22.958274119277547, 40.62633897672541], // TR_Lng, TR_Lat
    [22.95714214079803, 40.62604967919665], // TL_Lng, TL_Lat
    [22.95726139638822, 40.625741302609015], // BL_Lng, BL_Lat
    [22.958399710051793, 40.62603240460683]  // BR_Lng, BR_Lat
];

export const originalCoordinatesPavilion09 = [
    [22.955526632444588, 40.627696847914166], // Point 1
    [22.956017268444157, 40.62782812435381],  // Point 2
    [22.95616196441142, 40.62751507992297],    // Point 4
    [22.955676318176245, 40.62735981943942],
  
];

export const originalCoordinatesPavilion08 = [
    [22.955695890458486, 40.627323439953244], // Point 1
    [22.956190725559026, 40.62745571049257],  // Point 2
    [22.956557412225095, 40.62675120492787],  // Point 4
    [22.95601851562418, 40.62661144891476],   // Point 3
  
];


export const originalCoordinatesPavilion13 = [
    [22.954772736858075, 40.62773803921212], // TL_Lng, TL_Lat
    [22.955234486041434, 40.62785678418075], // TR_Lng, TR_Lat
    [22.955810045102055, 40.626560171571754], // BR_Lng, BR_Lat
    [22.955355860929785, 40.62644385221063], // BL_Lng, BL_Lat
];

export const originalCoordinatesPavilion10 = [
    [22.95533989770368, 40.62816918345234], // TL_Lng, TL_Lat
    [22.955783897839694, 40.62828922649021], // TR_Lng, TR_Lat
    [22.955973985907377, 40.627875098279674], // BR_Lng, BR_Lat
    [22.955532797365976, 40.62775281061727], // BL_Lng, BL_Lat
];

export const originalCoordinatesPavilion14 = [
    [22.95389228999221, 40.62868854869757], // TL_Lng, TL_Lat
    [22.95417654080606, 40.62877750968741], // TR_Lng, TR_Lat
    [22.95449442589677, 40.62815117257412],   // BR_Lng, BR_Lat
    [22.954210202423923, 40.62806858161122], // BL_Lng, BL_Lat
];


export const originalCoordinatesPavilion12 = [
    [22.95545193629377, 40.62624061195103], // TL_Lng, TL_Lat
    [22.95590124478491, 40.6263558108019],  // TR_Lng, TR_Lat
    [22.956142005057757, 40.625814474085246],// BR_Lng, BR_Lat
    [22.95569270821261, 40.62569844242796], // BL_Lng, BL_Lat
];

export const originalCoordinatesPavilion03 = [
    [22.957022460704688, 40.62772200056323], // TL_Lng, TL_Lat
    [22.95776300808390, 40.628037099515950],   // TR_Lng, TR_Lat
    [22.957995960745222, 40.627749172821325],// BR_Lng, BR_Lat
    [22.95727552940849, 40.62739224528502],  // BL_Lng, BL_Lat
 
];
export const originalCoordinatesPavilion17 = [
    [22.95646379809972, 40.628741472920154], // Top-left (TL_Lng, TL_Lat)
    [22.956718642993508, 40.62890550817880],  // Top-right (TR_Lng, TR_Lat)
    [22.95763133253294, 40.628134771104385],  // Bottom-right (BR_Lng, BR_Lat)
    [22.957340327599866, 40.62793612868643], // Bottom-left (BL_Lng, BL_Lat)
];
export const originalCoordinatesPavilion04 = [
  
    [22.958206741208556, 40.62658801307137], // Top-right
    [22.9572234814443, 40.6263473557849],  // Top-left
    [22.95730723445726, 40.626156922141604], // Bottom-left
    [22.958291776899216, 40.62640560549352]  // Botto
];
	

export const originalCoordinatesVellidis = [
  
    [22.954498905134000,40.62593262028770], // Top-right
    [22.955256739684300, 40.62609353319250],  // Top-left
    [22.955825115597100, 40.625227337876300], // Botto
    [22.955125923006000, 40.625011643224400], // Bottom-left
  
];

export const metropolitanExpoCoordinates04 = [
  [23.957693, 37.956622], // Top-left
  [23.958336, 37.956249], // Top-right
  [23.956963, 37.954913],
  [23.956293, 37.955298], // Bottom-right
  ];

export const metropolitanExpoCoordinates03 = [
  [ 23.95915555092112, 37.95583964897176 ],
  [ 23.95856159657287, 37.95615655558535 ],
[ 23.957227251744893, 37.95472843232562 ],
[ 23.957764986943623, 37.95440933691323 ]
]

export const metropolitanExpoCoordinates02 = [
  [ 23.959999260604853, 37.95540365709934 ],
  [ 23.959419903457636, 37.95577587754012 ],
  [ 23.95799296826171, 37.954261605338786 ],
  [ 23.958538109641147, 37.95393391215991 ]
]
export const metropolitanExpoCoordinates01 = [
  [ 23.960258694711783, 37.954646622861105 ],
  [ 23.95983403315749, 37.9548862595048 ],
  [ 23.95862672573249, 37.953621424480005 ],
  [ 23.959031095815284, 37.95340185527749 ]

]


// export const c3Coordinates = [
//   [22.956612382021376,40.626625028050654],
//   [22.956729948750308,40.62666237991607],
//   [22.957022498518256,40.62599211826637],
//   [22.956913134119418,40.625960991401115],];

export const c8Coordinates = [
  [22.95428765326727,40.6265313787708],
  [22.95670605045003,40.62719060099985],
  [22.956991319131806, 40.62644089678053],
  [22.95460698388119,40.625797824818015],
  
];

export const a6Coordinates = [
  [22.95376144919037,40.62775269051839],
  [22.9545060993162,40.6277492844268],
  [22.95450677075919,40.62805656232972],
  [22.95376341689251,40.62805813565981],
];

export const a8Coordinates = [
  [22.95368529988519,40.62874074393102],
  [22.954881469579,40.62904733666085],
  [22.95424190003444, 40.63044185997584],
  [22.95303686854704,40.63014347391955],
  ];

export const α11Coordinates = [
  [22.95492080877671,40.6284906288879],
  [22.95552412532662,40.62866976309116],
  [22.95528121407825,40.62916706424876],
  [22.95465809528604,40.62898877109685],
];

export const b7Coordinates = [
  [22.95613582624224,40.62773915982581],
  [22.95674348045385,40.62788243909554],
  [22.95632663104628,40.62879473654192],
  [22.95568854646736,40.62861620342596],
 
];

export const b8Coordinates = [
  [22.9565441171042,40.62668186586824],
  [22.95663587871747,40.62670825383104],
  [22.9563025654502,40.62744518099015],
  [22.95620089198066,40.62742165882644],
 
];

export const b10Coordinates = [
  [22.9561556506130,40.62742310816186],
  [22.95622739993167,40.62743951923825],
  [22.95586452379715,40.62827304214834],
  [22.95579617112042,40.6282599147165],
];

// export const b12Coordinates = [
//   [22.954129215120247,40.62718906749302],
//   [22.95419411472983,40.62722487353915],
//   [22.954513901689467,40.62638903550612],
//   [22.954477140492173,40.626383721086995],
// ];

export const b13Coordinates = [
  [22.95366577282192,40.62698369759196],
  [22.95576672667731,40.62866545997571],
  [22.95564755170378,40.62874832439071],
  [22.95352167396264,40.62709299026479],
];
export const pavilions = [
    {
      id: "Π15ΙΣ",
      coordinates: originalCoordinatesPavilion15, // Coordinates for Pavilion 15
      imageUrl:'', // Image for Pavilion 15
      rotation: -21 * (Math.PI / 180) ,// Rotation for Pavilion 15
      scaleFactor: { adjustmentFactorX: 0.018, adjustmentFactorY: 0.0365 },
      zIndex: 1
    },
   {
        id: "Π08",
        coordinates: originalCoordinatesPavilion08,
        imageUrl: '',
        rotation: -20 * (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.016, adjustmentFactorY: 0.024 },
        zIndex: 2
      },
      {
        id: "Π12ΙΣ",
        coordinates: originalCoordinatesPavilion12,
        imageUrl: '',
        rotation: -20 * (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.014, adjustmentFactorY: 0.018 },
        zIndex: 1
      },
      {
        id: "Π13",
        coordinates: originalCoordinatesPavilion13,
        imageUrl: '',
        rotation: -19 * (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.018, adjustmentFactorY: 0.042 },
        zIndex: 1
      },
       {
        id: "Π09",
        coordinates: originalCoordinatesPavilion09,
        imageUrl: '',
        rotation: -20 * (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.014, adjustmentFactorY: 0.013 }
      },
     {
        id: "Π10",
        coordinates: originalCoordinatesPavilion10,
        imageUrl: '',
        rotation: -20 * (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.0138, adjustmentFactorY: 0.016 }
      },
      {
        id: "Π16ΙΣ",
        coordinates: originalCoordinatesPavilion16,
        imageUrl: '',
        rotation: -19 * (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.014, adjustmentFactorY: 0.020 },
        zIndex: 1
      },
      {
        id: "Π17",
        coordinates: originalCoordinatesPavilion17, // Use the new Pavilion 17 coordinates
        imageUrl: '', // Add the correct image path for Pavilion 17
        rotation: -42 * (Math.PI / 180), // Specify rotation for Pavilion 17 if needed
        scaleFactor: { adjustmentFactorX: 0.009, adjustmentFactorY: 0.033 } // Custom scale factors for Pavilion 17
    },

    {
        id: "Π04",
        coordinates: originalCoordinatesPavilion04,
        imageUrl: '',
        rotation: -20 * (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.024, adjustmentFactorY: 0.032 }
      },
      {
        id: "Π02",
        coordinates: originalCoordinatesPavilion02,
        imageUrl: '',
        rotation: -39 * (Math.PI / 180), // Specify rotation for Pavilion 17 if needed
        scaleFactor: { adjustmentFactorX: 0.012, adjustmentFactorY: 0.044 }, // Custom scale factors for Pavilion 17
        zIndex: 1
      },
      {
        id: "Π03",
        coordinates: originalCoordinatesPavilion03,
        imageUrl: '',
        rotation: 150 * (Math.PI / 180), // Specify rotation for Pavilion 17 if needed
        scaleFactor: { adjustmentFactorX: 0.018, adjustmentFactorY: 0.019 } // Custom scale factors for Pavilion 17
      },
      {
        id: "Π07",
        coordinates: originalCoordinatesPavilion07,
        imageUrl: '',
        rotation: -18 * (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.008, adjustmentFactorY: 0.03 },
        zIndex: 1
      },
      {
        id: "Π06",
        coordinates: originalCoordinatesPavilion06,
        imageUrl: '',
        rotation: -18 * (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.034, adjustmentFactorY: 0.06 }
      },
      {
        id: "Π01",
        coordinates: originalCoordinatesPavilion01,
        imageUrl: '',
        rotation: 32 * (Math.PI / 180), // Specify rotation for Pavilion 17 if needed
        scaleFactor:  { adjustmentFactorX: 0.011, adjustmentFactorY: 0.01 }
      },
      {
        id: "Π14",
        coordinates: originalCoordinatesPavilion14,
        imageUrl: '',
        rotation: -21 * (Math.PI / 180),
        scaleFactor: {adjustmentFactorX: 0.0115, adjustmentFactorY: 0.020 }
      },
      {
        id: "Π05",
        coordinates: originalCoordinatesPavilion05,
        imageUrl: '',
        rotation: 160 * (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.027, adjustmentFactorY: 0.038 }
      },
      {
        id: "Vellidis",
        coordinates: originalCoordinatesVellidis,
        imageUrl: '',
        rotation: -18 * (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.045, adjustmentFactorY: 0.031 }
      },
      {
        id: 'HALL_1',
        coordinates: metropolitanExpoCoordinates04,
        imageUrl: '',
        rotation: 39.0 * (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.022, adjustmentFactorY: 0.053 }
      },
      {
        id: 'HALL_2',
        coordinates: metropolitanExpoCoordinates03,
        imageUrl: '',
        rotation: 39.0 * (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.022, adjustmentFactorY: 0.053 }
      },
      {
        id: 'HALL_3',
        coordinates: metropolitanExpoCoordinates02,
        imageUrl: '',
        rotation: 37* (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.018, adjustmentFactorY: 0.059 }
      },
      {
        id: 'HALL_4',
        coordinates: metropolitanExpoCoordinates01,
        imageUrl: '',
        rotation: 37* (Math.PI / 180),
        scaleFactor: { adjustmentFactorX: 0.012, adjustmentFactorY: 0.052 }
      },
      // {
      //   id: 'C03',
      //   coordinates: c3Coordinates,
      //   imageUrl: '',
      //   rotation: 0 * (Math.PI / 180),
      //   scaleFactor: { adjustmentFactorX: 0.012, adjustmentFactorY: 0.052 }
      // },
    {
      id:`C08`,
      coordinates: c8Coordinates,
      rotation: -20 * (Math.PI / 180),
      scaleFactor: { adjustmentFactorX: 0.18, adjustmentFactorY: 0.28 },
    },
    {
      id:`ΥΧΑ06`,
      coordinates: a6Coordinates,
      rotation: 0 * (Math.PI / 180),
      scaleFactor: { adjustmentFactorX: 0.12, adjustmentFactorY: 0.28 }
    },
    {
      id:`ΥΧΑ08`,
      coordinates: a8Coordinates,
      rotation: -21 * (Math.PI / 180),
      scaleFactor: { adjustmentFactorX: 0.15, adjustmentFactorY: 0.30 }
    },
    {
      id:`ΥΧΑ11`,
      coordinates: α11Coordinates,
      rotation: -21 * (Math.PI / 180),
      scaleFactor: { adjustmentFactorX: 0.06, adjustmentFactorY: 0.12 }
    },
    {
      id:`ΥΧΒ07`,
      coordinates: b7Coordinates,
      rotation: -21 * (Math.PI / 180),
      scaleFactor: { adjustmentFactorX: 0.115, adjustmentFactorY: 0.24 }
    },
    {
      id:`ΥΧΒ08`,
      coordinates: b8Coordinates,
      rotation: -21 * (Math.PI / 180),
      scaleFactor: { adjustmentFactorX: 0.007, adjustmentFactorY: 0.15},
      zIndex: 1
    },
    {
        id:`ΥΧΒ10`,
        coordinates:b10Coordinates,
        rotation:-15*(Math.PI/180),
        scaleFactor:{adjustmentFactorX :  0.008,adjustmentFactorY :0.19}
    },
    // {
    //     id:`B12`,
    //     coordinates:b12Coordinates,
    //     imageUrl:'',
    //     rotation:-20*(Math.PI/180),
    //     scaleFactor:{adjustmentFactorX : 0.012,adjustmentFactorY : 0.052}
    // },
    {
        id:`ΥΧΒ13`,
        coordinates:b13Coordinates,
        rotation:-20*(Math.PI/180),
        scaleFactor:{adjustmentFactorX : 0.012,adjustmentFactorY : 0.052}
    }

    ];